define('HomeFeaturedProducts.Product.View', [
    'home_featured_products_product.tpl',
    'ProductViews.Price.View',
    'Backbone'
], function HomeFeaturedProductsProductView(
    homeFeaturedProductsProductTpl,
    ProductViewsPriceView,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: homeFeaturedProductsProductTpl,
        childViews: {
            'Item.Price': function ItemPrice() {
                //Fix to show prices on products
                this.model.set('item',new Backbone.Model(this.model.attributes));
                return new ProductViewsPriceView({
                    model: this.model,
                    origin: 'RELATEDITEM'
                });
            }
        },
        getContext: function getContext() {
            return {
                itemURL: this.model.get('_url'),
                linkAttributes: this.model.getFullLink(),
                show_top_rated: !!this.model.get('custitem_web_rev_1_score'),
                top_rated: this.model.get('custitem_web_rev_1_score') + ' Points',
                vintage: this.model.get('custitem_aws_vintage'),
                itemName: this.model.get('_name') || this.model.Name,
                thumbnailURL: this.model.get('_thumbnail').url,
                thumbnailAltImageText: this.model.get('_thumbnail').altimagetext,
                track_productlist_list: this.model.get('track_productlist_list'),
                track_productlist_position: this.model.get('track_productlist_position'),
                track_productlist_category: this.model.get('track_productlist_category'),
                sku: this.model.get('_sku'),
                itemId: this.model.get('_id')
            };
        }
    });
});
